// maintain alphabetical order
export const enMetrics = {
  Auctions: 'Auctions',
  BidRequests: 'Bid Requests',
  BidResponseRate: 'Bid Response Rate',
  BidResponses: 'Bid Responses',
  BidTimeoutRate: 'Bid Timeout Rate',
  BidWinRate: 'Bid Win Rate',
  CPM: 'CPM',
  CPMPerSecond: 'CPM Per Second',
  EndpointRequests: 'Endpoint Requests',
  EndpointRequestsECPM: 'Endpoint Requests ECPM',
  FillRate: 'Fill Rate',
  Impressions: 'Impressions',
  PaidPodClearRate: 'Paid Pod Clear Rate',
  PodClearRate: 'Pod Clear Rate',
  PodFillRate: 'Pod Fill Rate',
  RenderRate: 'Render Rate',
  Revenue: 'Revenue',
  WinningBids: 'Winning Bids',
};